'use strict';

module.exports = function (column) {

  var ascending = this.orderBy.ascending;

  this.currentlySorting = { column: column, ascending: ascending };

  if (typeof this.opts.customSorting[column] == 'undefined') return this.defaultSort(column, ascending);

  return this.opts.customSorting[column](ascending);
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-tables-2/compiled/methods/get-sort-fn.js
// module id = 246
// module chunks = 0